<template>
  <div
    class="layout-vertical"
    :class="{ 'layout-vertical_no-sidebar': hideSidebar }"
  >
    <div id="layout-wrapper">
      <SideBar v-if="!hideSidebar" />
      <div class="layout-vertical__main-content">
        <div class="layout-vertical__page-content">
          <div class="layout-vertical__container-fluid">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { SideBar } from "@/widgets/SideBar/index";

const route = useRoute();
const hideSidebar = computed(() => Boolean(route.meta?.hideSidebar));
</script>

<style lang="scss" scoped>
.layout-vertical {
  &__main-content {
    min-height: 100vh;
    margin-left: 195px;
    overflow: hidden;
    position: relative;
  }
  &__container-fluid {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  &_no-sidebar {
    .layout-vertical__main-content {
      margin-left: 0;
    }
  }
}
</style>
